module.exports = __webpack_public_path__ + "static/media/vertical-ellipsis.22d3550b.svg";